var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c("b-loading", {
        attrs: {
          "is-full-page": _vm.isFullPage,
          active: _vm.isLoading,
          "can-cancel": true
        },
        on: {
          "update:active": function($event) {
            _vm.isLoading = $event
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "sidebar sidebar-fixed bg-white",
          attrs: { id: "sidebarMenu" }
        },
        [
          _c("div", { staticClass: "sidebar-header" }, [
            _c("h5", [_vm._v(" ")]),
            _vm._v(" "),
            _c(
              "a",
              { attrs: { href: "", id: "sidebarMenuClose" } },
              [
                _c("feather", {
                  staticClass:
                    "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                  attrs: { type: "x" }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "sidebar-body" }, [
            _c(
              "div",
              [
                _vm._l(_vm.inputSearchForms, function(form, i) {
                  return form.name
                    ? _c("ul", { staticClass: "sidebar-nav" }, [
                        _c("li", { staticClass: "nav-label mg-b-10-f" }, [
                          _vm._v(" ")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group" }, [
                          _c(
                            "label",
                            { staticClass: "has-text-weight-semibold" },
                            [_vm._v(_vm._s(form.name))]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: form.value,
                                expression: "form.value"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              id: form.id,
                              placeholder: form.name
                            },
                            domProps: { value: form.value },
                            on: {
                              keyup: _vm.textKeyupEvent,
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(form, "value", $event.target.value)
                              }
                            }
                          })
                        ])
                      ])
                    : _vm._e()
                }),
                _vm._v(" "),
                _vm._l(_vm.checkboxSearchForms, function(form, i) {
                  return _c("ul", { staticClass: "sidebar-nav" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c(
                          "label",
                          {
                            staticClass: " d-block has-text-weight-semibold",
                            attrs: { for: "formGroupExampleInput" }
                          },
                          [_vm._v(_vm._s(form.name))]
                        ),
                        _vm._v(" "),
                        _vm._l(form.subs, function(form1, i) {
                          return _c(
                            "div",
                            {
                              staticClass:
                                "ml-2 custom-control custom-radio mb-1"
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: form.value,
                                    expression: "form.value"
                                  }
                                ],
                                staticClass: "custom-control-input",
                                attrs: {
                                  type: "radio",
                                  id: form1.codeCode,
                                  name: form.id
                                },
                                domProps: {
                                  value: form1.codeCode,
                                  checked: _vm._q(form.value, form1.codeCode)
                                },
                                on: {
                                  click: _vm.checkClickEvent,
                                  change: function($event) {
                                    return _vm.$set(
                                      form,
                                      "value",
                                      form1.codeCode
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "custom-control-label",
                                  attrs: { for: form1.codeCode }
                                },
                                [_vm._v(_vm._s(form1.codeName))]
                              )
                            ]
                          )
                        })
                      ],
                      2
                    )
                  ])
                }),
                _vm._v(" "),
                _vm._l(_vm.dateSearchForms, function(form, i) {
                  return _c("ul", { staticClass: "sidebar-nav mg-t-35-f" }, [
                    _c("li", { staticClass: "nav-label mg-b-10-f" }, [
                      _vm._v("Date Search")
                    ]),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "d-block",
                        attrs: { for: "formGroupExampleInput" }
                      },
                      [_vm._v(_vm._s(form.name))]
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      { staticClass: "nav-item" },
                      [
                        _c("date-picker", {
                          staticClass: "form-control",
                          attrs: {
                            config: _vm.datePickerOptions,
                            autocomplete: "off",
                            placeholder: "From date",
                            id: form.fid,
                            "aria-label": "Search",
                            ignoreReadonly: ""
                          },
                          on: { "dp-change": _vm.dateKeyupEvent },
                          model: {
                            value: form.fvalue,
                            callback: function($$v) {
                              _vm.$set(form, "fvalue", $$v)
                            },
                            expression: "form.fvalue"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      { staticClass: "nav-item" },
                      [
                        _c("date-picker", {
                          staticClass: "form-control",
                          attrs: {
                            config: _vm.datePickerOptions,
                            autocomplete: "off",
                            placeholder: "To date",
                            id: form.eid,
                            "aria-label": "Search",
                            ignoreReadonly: ""
                          },
                          on: { "dp-change": _vm.dateKeyupEvent },
                          model: {
                            value: form.evalue,
                            callback: function($$v) {
                              _vm.$set(form, "evalue", $$v)
                            },
                            expression: "form.evalue"
                          }
                        })
                      ],
                      1
                    )
                  ])
                })
              ],
              2
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "content content-components" }, [
        _c("div", { staticClass: "pd-x-0 pd-lg-x-10 pd-xl-x-0" }, [
          _c(
            "div",
            {
              staticClass:
                "d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30"
            },
            [
              _c("div", [
                _c("nav", { attrs: { "aria-label": "breadcrumb" } }, [
                  _c(
                    "ol",
                    { staticClass: "breadcrumb breadcrumb-style1 mg-b-10" },
                    [
                      _c("li", { staticClass: "breadcrumb-item" }, [
                        _vm._v(_vm._s(this.mainName))
                      ]),
                      _vm._v(" "),
                      _c(
                        "li",
                        {
                          staticClass: "breadcrumb-item",
                          attrs: { "aria-current": "page" }
                        },
                        [_vm._v(_vm._s(this.subName))]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("h4", { staticClass: "mg-b-0 tx-spacing--1" }, [
                    _vm._v(_vm._s(this.subName))
                  ])
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: " pd-x-0 pd-lg-x-10 pd-xl-x-0" }, [
            _c("div", { staticClass: "col-sm-6 col-lg-5" }, [
              _c(
                "ul",
                {
                  staticClass: "cardborder nav nav-tabs",
                  attrs: { id: "myTab", role: "tablist" }
                },
                [
                  _c("li", { staticClass: "nav-item" }, [
                    _c(
                      "a",
                      {
                        staticClass: "nav-link active",
                        attrs: {
                          id: "wait-tab",
                          "data-toggle": "tab",
                          href: "#waits",
                          role: "tab",
                          "aria-controls": "waits",
                          "aria-selected": "false"
                        },
                        on: {
                          click: function($event) {
                            return _vm.createSearchForm(2, true)
                          }
                        }
                      },
                      [_vm._v("Wait")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "nav-item" }, [
                    _c(
                      "a",
                      {
                        staticClass: "nav-link",
                        attrs: {
                          id: "analysis-tab",
                          "data-toggle": "tab",
                          href: "#analysis",
                          role: "tab",
                          "aria-controls": "analysis",
                          "aria-selected": "false"
                        },
                        on: {
                          click: function($event) {
                            return _vm.classifyData(1, true)
                          }
                        }
                      },
                      [_vm._v("Task List")]
                    )
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card card-body" }, [
              _c(
                "div",
                {
                  staticClass: "tab-content mg-t-20",
                  attrs: { id: "myTabContent" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "tab-pane fade lm-overflow show active",
                      attrs: {
                        id: "waits",
                        role: "tabpanel",
                        "aria-labelledby": "wait-tab"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-none d-webkit-box tx-right-f mg-xs-y-15-f"
                        },
                        [
                          _c(
                            "b-select",
                            {
                              attrs: { placeholder: "Select a Pipeline" },
                              model: {
                                value: _vm.selPipeline,
                                callback: function($$v) {
                                  _vm.selPipeline = $$v
                                },
                                expression: "selPipeline"
                              }
                            },
                            _vm._l(_vm.pipelines, function(option) {
                              return _c(
                                "option",
                                { domProps: { value: option } },
                                [
                                  _vm._v(
                                    "\n                                            " +
                                      _vm._s(option.name) +
                                      "\n                                        "
                                  )
                                ]
                              )
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5-f",
                              on: {
                                click: function($event) {
                                  return _vm.runDialogHandler()
                                }
                              }
                            },
                            [
                              _c("feather", {
                                staticClass:
                                  "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                                attrs: { type: "refresh-cw" }
                              }),
                              _vm._v("Run")
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "section",
                        [
                          _c(
                            "b-field",
                            { attrs: { grouped: "", "group-multiline": "" } },
                            [
                              _c(
                                "b-select",
                                {
                                  attrs: { disabled: !_vm.wIsPaginated },
                                  model: {
                                    value: _vm.wPerPage,
                                    callback: function($$v) {
                                      _vm.wPerPage = $$v
                                    },
                                    expression: "wPerPage"
                                  }
                                },
                                [
                                  _c("option", { attrs: { value: "20" } }, [
                                    _vm._v("20")
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "50" } }, [
                                    _vm._v("50")
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "100" } }, [
                                    _vm._v("100")
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "200" } }, [
                                    _vm._v("200")
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "section",
                        [
                          _c(
                            "b-table",
                            {
                              attrs: {
                                id: "preTable",
                                data: _vm.isEmpty ? [] : _vm.preData,
                                "checked-rows": _vm.waitCheckedRows,
                                loading: _vm.loading,
                                paginated: "",
                                hoverable: "",
                                striped: "",
                                "backend-pagination": "",
                                checkable: "",
                                total: _vm.total,
                                "per-page": _vm.perPage,
                                "aria-next-label": "Next page",
                                "aria-previous-label": "Previous page",
                                "aria-page-label": "Page",
                                "aria-current-label": "Current page",
                                "backend-sorting": ""
                              },
                              on: {
                                "update:checkedRows": function($event) {
                                  _vm.waitCheckedRows = $event
                                },
                                "update:checked-rows": function($event) {
                                  _vm.waitCheckedRows = $event
                                },
                                "page-change": _vm.onPageChange
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(props) {
                                    return _vm._l(_vm.preHeader, function(
                                      form,
                                      i
                                    ) {
                                      return form.columnAttr == "runid"
                                        ? _c(
                                            "b-table-column",
                                            {
                                              key: i,
                                              attrs: {
                                                field: form.columnAttr,
                                                label: form.columnName,
                                                centered: "",
                                                sortable: ""
                                              }
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  attrs: { href: "#" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.classifySample(
                                                        props.row.id
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      props.row[form.columnAttr]
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _c(
                                            "b-table-column",
                                            {
                                              key: i,
                                              attrs: {
                                                field: form.columnAttr,
                                                label: form.columnName,
                                                centered: "",
                                                sortable: ""
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  props.row[form.columnAttr]
                                                ) + " "
                                              )
                                            ]
                                          )
                                    })
                                  }
                                }
                              ])
                            },
                            [
                              _vm._v(" "),
                              _c("template", { slot: "empty" }, [
                                _c("section", { staticClass: "section" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "content has-text-grey has-text-centered"
                                    },
                                    [_c("p", [_vm._v("Nothing here.")])]
                                  )
                                ])
                              ])
                            ],
                            2
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "pd-x-0 pd-lg-x-10 pd-xl-x-0" },
                        [
                          _c("div", { staticClass: "row row-xs" }, [
                            _c("div", { staticClass: "col-lg-12 mg-t-10" }, [
                              _c("section", [
                                _vm.datacolumns.length > 0
                                  ? _c(
                                      "ul",
                                      {
                                        staticClass: "nav nav-line",
                                        staticStyle: { "padding-left": "10px" },
                                        attrs: { id: "myTab5", role: "tablist" }
                                      },
                                      _vm._l(_vm.preTabHeader, function(
                                        form,
                                        i
                                      ) {
                                        return _vm.preMid === form.id
                                          ? _c(
                                              "li",
                                              { staticClass: "nav-item" },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "nav-link active",
                                                    attrs: {
                                                      id: form.id,
                                                      "data-toggle": "tab",
                                                      href: "#",
                                                      role: "tab",
                                                      "aria-controls": "home",
                                                      "aria-selected": "true"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.classifySampleHeader(
                                                          form.id,
                                                          form.jobOrder
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(form.menuName)
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : form.jobOrder != 6
                                          ? _c(
                                              "li",
                                              { staticClass: "nav-item" },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass: "nav-link",
                                                    attrs: {
                                                      id: form.id,
                                                      "data-toggle": "tab",
                                                      href: "#",
                                                      role: "tab",
                                                      "aria-controls":
                                                        "profile",
                                                      "aria-selected": "false"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.classifySampleHeader(
                                                          form.id,
                                                          form.jobOrder
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(form.menuName)
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      }),
                                      0
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", {}, [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "white-space": "nowrap",
                                        "overflow-x": "scroll"
                                      }
                                    },
                                    [
                                      _c("b-table", {
                                        attrs: {
                                          data: _vm.items,
                                          hoverable: "",
                                          striped: "",
                                          paginated: "",
                                          "per-page": "15"
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "default",
                                            fn: function(props) {
                                              return _vm._l(
                                                _vm.datacolumns,
                                                function(form, i) {
                                                  return form.field ==
                                                    "receptionno"
                                                    ? _c(
                                                        "b-table-column",
                                                        {
                                                          key: i,
                                                          attrs: {
                                                            field: form.field,
                                                            label: form.label,
                                                            centered: "",
                                                            sortable: ""
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "a",
                                                            {
                                                              attrs: {
                                                                href:
                                                                  "#modal52",
                                                                "data-toggle":
                                                                  "modal",
                                                                "data-animation":
                                                                  "effect-flip-horizontal"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.sendId(
                                                                    props.row
                                                                      .receptionId
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    props.row[
                                                                      form.field
                                                                    ]
                                                                  ) +
                                                                  " "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _c(
                                                        "b-table-column",
                                                        {
                                                          key: i,
                                                          attrs: {
                                                            field: form.field,
                                                            label: form.label,
                                                            centered: "",
                                                            sortable: ""
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              props.row[
                                                                form.field
                                                              ]
                                                            )
                                                          )
                                                        ]
                                                      )
                                                }
                                              )
                                            }
                                          }
                                        ])
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ])
                            ])
                          ])
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "tab-pane fade",
                      attrs: {
                        id: "analysis",
                        role: "tabpanel",
                        "aria-labelledby": "analysis-tab"
                      }
                    },
                    [
                      _c(
                        "section",
                        [
                          _c(
                            "b-field",
                            { attrs: { grouped: "", "group-multiline": "" } },
                            [
                              _c(
                                "b-select",
                                {
                                  attrs: { disabled: !_vm.isPaginated },
                                  model: {
                                    value: _vm.perPage,
                                    callback: function($$v) {
                                      _vm.perPage = $$v
                                    },
                                    expression: "perPage"
                                  }
                                },
                                [
                                  _c("option", { attrs: { value: "20" } }, [
                                    _vm._v("20")
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "50" } }, [
                                    _vm._v("50")
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "100" } }, [
                                    _vm._v("100")
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "200" } }, [
                                    _vm._v("200")
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "section",
                        [
                          _c(
                            "b-table",
                            {
                              ref: "table",
                              attrs: {
                                id: "preTable",
                                data: _vm.isEmpty ? [] : _vm.aSampleData,
                                hoverable: "",
                                paginated: "",
                                striped: "",
                                detailed: "",
                                "backend-pagination": "",
                                total: _vm.total,
                                "per-page": _vm.perPage,
                                "aria-next-label": "Next page",
                                "aria-previous-label": "Previous page",
                                "aria-page-label": "Page",
                                "aria-current-label": "Current page",
                                "backend-sorting": "",
                                "detail-key": "id",
                                "show-detail-icon": false,
                                "opened-detailed": _vm.defaultOpenedDetails
                              },
                              on: {
                                "page-change": _vm.onPageChange,
                                "details-open": function(row, index) {
                                  return _vm.closeAllOtherToggle(row, index)
                                },
                                dblclick: function(row, index) {
                                  return _vm.doubleClickHandler(row, index)
                                }
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(props) {
                                    return _vm._l(_vm.nowHeader, function(
                                      form,
                                      i
                                    ) {
                                      return Number(i) == 0
                                        ? _c(
                                            "b-table-column",
                                            {
                                              key: form.id,
                                              attrs: {
                                                "custom-key": form.id,
                                                field: "no",
                                                label: "No",
                                                centered: ""
                                              }
                                            },
                                            [_vm._v(_vm._s(props.row.no))]
                                          )
                                        : Number(i) == 1
                                        ? _c(
                                            "b-table-column",
                                            {
                                              key: form.id,
                                              attrs: {
                                                "custom-key": form.id,
                                                field: form.columnCode,
                                                label: form.columnName,
                                                centered: ""
                                              }
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href: "#",
                                                    id: props.index
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.aToggle(
                                                        props.row
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        props.row[
                                                          form.columnCode
                                                        ]
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _c(
                                            "b-table-column",
                                            {
                                              key: form.id,
                                              attrs: {
                                                "custom-key": form.id,
                                                field: form.columnCode,
                                                label: form.columnName,
                                                centered: ""
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  props.row[form.columnCode]
                                                )
                                              )
                                            ]
                                          )
                                    })
                                  }
                                },
                                {
                                  key: "detail",
                                  fn: function(props) {
                                    return [
                                      _c(
                                        "ul",
                                        {
                                          staticClass: "nav nav-line",
                                          attrs: {
                                            id: "myTab5",
                                            role: "tablist"
                                          }
                                        },
                                        _vm._l(_vm.tabHeader, function(
                                          form,
                                          i
                                        ) {
                                          return i == 0
                                            ? _c(
                                                "li",
                                                { staticClass: "nav-item" },
                                                [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass: "nav-link",
                                                      attrs: {
                                                        id: form.id,
                                                        "data-toggle": "tab",
                                                        href: "#",
                                                        role: "tab",
                                                        "aria-controls": "home",
                                                        "aria-selected": "true"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.classifyPreSampleHeader(
                                                            form
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(form.menuName)
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm.tabHeader.length - 2 > i
                                            ? _c(
                                                "li",
                                                { staticClass: "nav-item" },
                                                [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass: "nav-link",
                                                      attrs: {
                                                        id: form.id,
                                                        "data-toggle": "tab",
                                                        href: "#",
                                                        role: "tab",
                                                        "aria-controls": "home",
                                                        "aria-selected": "false"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.classifyPreSampleHeader(
                                                            form
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(form.menuName)
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm.tabHeader.length - 2 == i
                                            ? _c(
                                                "li",
                                                { staticClass: "nav-item" },
                                                [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "nav-link active",
                                                      attrs: {
                                                        id: form.id,
                                                        "data-toggle": "tab",
                                                        href: "#",
                                                        role: "tab",
                                                        "aria-controls": "home",
                                                        "aria-selected": "false"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.classifyPreSampleHeader(
                                                            form
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(form.menuName)
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        }),
                                        0
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-table",
                                        {
                                          ref: "sampleTable",
                                          attrs: {
                                            id: "preSampleTable",
                                            columns: _vm.preSampleHeader,
                                            data: _vm.isEmpty
                                              ? []
                                              : _vm.aPreSampleData,
                                            hoverable: "",
                                            striped: ""
                                          }
                                        },
                                        [
                                          _c("template", { slot: "empty" }, [
                                            _c(
                                              "section",
                                              { staticClass: "section" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "content has-text-grey has-text-centered"
                                                  },
                                                  [
                                                    _c("p", [
                                                      _vm._v("Nothing here.")
                                                    ])
                                                  ]
                                                )
                                              ]
                                            )
                                          ])
                                        ],
                                        2
                                      )
                                    ]
                                  }
                                }
                              ])
                            },
                            [
                              _vm._v(" "),
                              _c("template", { slot: "empty" }, [
                                _c("section", { staticClass: "section" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "content has-text-grey has-text-centered"
                                    },
                                    [_c("p", [_vm._v("Nothing here.")])]
                                  )
                                ])
                              ])
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "d-none" },
                            [
                              _c("b-table", {
                                ref: "sampleTable",
                                attrs: { id: "preSampleTable" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "section",
                        [
                          _c(
                            "b-field",
                            { attrs: { label: "Task Queue" } },
                            [
                              _c("b-taginput", {
                                directives: [
                                  {
                                    name: "sortable",
                                    rawName: "v-sortable",
                                    value: _vm.sortableOptions,
                                    expression: "sortableOptions"
                                  }
                                ],
                                staticClass: "taginput-sortable",
                                attrs: { size: "is-large", ellipsis: "" },
                                model: {
                                  value: _vm.tags,
                                  callback: function($$v) {
                                    _vm.tags = $$v
                                  },
                                  expression: "tags"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  )
                ]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "modal5",
            tabindex: "-1",
            role: "dialog",
            "aria-labelledby": "exampleModalLabel5",
            "aria-hidden": "true"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-dialog-centered chat-width",
              attrs: { role: "document" }
            },
            [
              _c("div", { staticClass: "modal-content tx-14 chat-height" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [_c("Chat")], 1)
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "modal6",
            tabindex: "-1",
            role: "dialog",
            "aria-labelledby": "exampleModalLabel6",
            "aria-hidden": "true"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-dialog-centered",
              attrs: { role: "document" }
            },
            [
              _c("div", { staticClass: "modal-content tx-14" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("p", { staticClass: "mg-b-0" }, [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("p", { staticClass: "mg-b-0" }),
                  _c("div", { staticClass: "card" }, [
                    _c("div", { staticClass: "card-body" }, [
                      _vm.selPipeline.name
                        ? _c(
                            "div",
                            [
                              _c("h6", [
                                _c(
                                  "span",
                                  { staticClass: "badge badge-light" },
                                  [_vm._v(_vm._s(_vm.selPipeline.name))]
                                )
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.selPipeline.param, function(data) {
                                return _c("ul", { staticClass: "list-group" }, [
                                  _c(
                                    "li",
                                    {
                                      staticClass:
                                        "list-group-item d-flex justify-content-between align-items-center"
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t" +
                                          _vm._s(data.key) +
                                          "\n\t\t\t\t\t\t\t\t"
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "badge badge-primary badge-pill"
                                        },
                                        [_vm._v(_vm._s(data.value))]
                                      )
                                    ]
                                  )
                                ])
                              })
                            ],
                            2
                          )
                        : _c("div", [_vm._m(2)])
                    ]),
                    _vm._v(" "),
                    _vm.waitCheckedRows.length != 0
                      ? _c("div", { staticClass: "card-header" })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.waitCheckedRows.length == 1
                      ? _c(
                          "div",
                          { staticClass: "card-header" },
                          _vm._l(_vm.waitCheckedRows, function(row, index) {
                            return _c("div", [
                              _vm._m(3, true),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: row.runId,
                                    expression: "row.runId"
                                  }
                                ],
                                staticClass: "form-control mb-1",
                                staticStyle: { width: "20rem" },
                                attrs: { type: "form-control" },
                                domProps: { value: row.runId },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(row, "runId", $event.target.value)
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _vm._m(4, true),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: row.path,
                                    expression: "row.path"
                                  }
                                ],
                                staticClass: "form-control",
                                staticStyle: { width: "27rem" },
                                attrs: { type: "form-control" },
                                domProps: { value: row.path },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(row, "path", $event.target.value)
                                  }
                                }
                              })
                            ])
                          }),
                          0
                        )
                      : _c("div", { staticClass: "card-header" }, [_vm._m(5)])
                  ]),
                  _vm._v(" "),
                  _c("p")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary tx-13",
                      attrs: { type: "button", "data-dismiss": "modal" }
                    },
                    [_vm._v("Close")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary tx-13",
                      attrs: { type: "button", "data-dismiss": "modal" },
                      on: { click: _vm.addRun }
                    },
                    [_vm._v("Run")]
                  )
                ])
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "modal7",
            tabindex: "-1",
            role: "dialog",
            "aria-labelledby": "exampleModalLabel7",
            "aria-hidden": "true"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-xl",
              attrs: { role: "document" }
            },
            [
              _c("div", { staticClass: "modal-content" }, [
                _vm._m(6),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [_c("Task")], 1)
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "v-app",
        [
          _c(
            "v-dialog",
            {
              attrs: {
                "hide-overlay": "",
                "max-width": "600",
                transition: "dialog-bottom-transition",
                scrollable: ""
              },
              model: {
                value: _vm.dialog,
                callback: function($$v) {
                  _vm.dialog = $$v
                },
                expression: "dialog"
              }
            },
            [
              _c(
                "v-card",
                { attrs: { tile: "", height: "800px" } },
                [
                  _c(
                    "v-toolbar",
                    {
                      attrs: { flat: "", dark: "", color: "primary darken-1" }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "", dark: "" },
                          on: {
                            click: function($event) {
                              _vm.dialog = false
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("mdi-close")])],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-toolbar-title", [_vm._v("Pipeline Settings")]),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { dark: "", text: "" },
                              on: {
                                click: function($event) {
                                  return _vm.addRun()
                                }
                              }
                            },
                            [
                              _c("v-icon", [
                                _vm._v(
                                  "\n                      mdi-desktop-mac-dashboard\n                    "
                                )
                              ]),
                              _vm._v(
                                "\n                      Run\n                  "
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-menu", {
                        attrs: { bottom: "", right: "", "offset-y": "" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-list",
                        { attrs: { "three-line": "", subheader: "" } },
                        [
                          _c("v-subheader", [_vm._v("User Controls")]),
                          _vm._v(" "),
                          _c(
                            "v-form",
                            { ref: "form", attrs: { "lazy-validation": "" } },
                            [
                              _c(
                                "v-list-item",
                                [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v("Serial")
                                      ]),
                                      _vm._v(" "),
                                      _c("v-text-field", {
                                        ref: "serial",
                                        attrs: {
                                          label: "Serial",
                                          rules: [
                                            _vm.rules.required,
                                            _vm.rules.blank,
                                            _vm.rules.str
                                          ],
                                          required: ""
                                        },
                                        model: {
                                          value: _vm.serial,
                                          callback: function($$v) {
                                            _vm.serial = $$v
                                          },
                                          expression: "serial"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-item",
                                [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v("Input Path")
                                      ]),
                                      _vm._v(" "),
                                      _c("v-text-field", {
                                        ref: "inputPath",
                                        attrs: {
                                          label: "Input Path",
                                          rules: [
                                            _vm.rules.required,
                                            _vm.rules.blank
                                          ],
                                          required: ""
                                        },
                                        model: {
                                          value: _vm.inputPath,
                                          callback: function($$v) {
                                            _vm.inputPath = $$v
                                          },
                                          expression: "inputPath"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-item",
                                [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v("Database")
                                      ]),
                                      _vm._v(" "),
                                      _c("v-select", {
                                        ref: "database",
                                        attrs: {
                                          items: _vm.databaseOptions,
                                          rules: [_vm.rules.required]
                                        },
                                        model: {
                                          value: _vm.database,
                                          callback: function($$v) {
                                            _vm.database = $$v
                                          },
                                          expression: "database"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-item",
                                [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v("% Identity")
                                      ]),
                                      _vm._v(" "),
                                      _c("v-select", {
                                        ref: "identity",
                                        attrs: {
                                          items: _vm.identityOptions,
                                          rules: [_vm.rules.required],
                                          label:
                                            "The value of Representative identity in Reference DB"
                                        },
                                        model: {
                                          value: _vm.identity,
                                          callback: function($$v) {
                                            _vm.identity = $$v
                                          },
                                          expression: "identity"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-item",
                                [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v("TRIM_FWD")
                                      ]),
                                      _vm._v(" "),
                                      _c("v-text-field", {
                                        ref: "trim_fwd",
                                        attrs: {
                                          label:
                                            "The value to trim the length of forward reads of R1 fastq",
                                          rules: [_vm.rules.required],
                                          required: ""
                                        },
                                        model: {
                                          value: _vm.trim_fwd,
                                          callback: function($$v) {
                                            _vm.trim_fwd = $$v
                                          },
                                          expression: "trim_fwd"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-item",
                                [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v("TRIM_REV")
                                      ]),
                                      _vm._v(" "),
                                      _c("v-text-field", {
                                        ref: "trim_rev",
                                        attrs: {
                                          label:
                                            "The value to trim the length of reverse reads of R2 fastq",
                                          rules: [_vm.rules.required],
                                          required: ""
                                        },
                                        model: {
                                          value: _vm.trim_rev,
                                          callback: function($$v) {
                                            _vm.trim_rev = $$v
                                          },
                                          expression: "trim_rev"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-item",
                                [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v("TRIM_MERGED")
                                      ]),
                                      _vm._v(" "),
                                      _c("v-text-field", {
                                        ref: "trim_merged",
                                        attrs: {
                                          label:
                                            "The value to trim the length of merged reads",
                                          rules: [_vm.rules.required],
                                          required: ""
                                        },
                                        model: {
                                          value: _vm.trim_merged,
                                          callback: function($$v) {
                                            _vm.trim_merged = $$v
                                          },
                                          expression: "trim_merged"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-item",
                                [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v("METHOD")
                                      ]),
                                      _vm._v(" "),
                                      _c("v-select", {
                                        ref: "method",
                                        attrs: {
                                          items: _vm.methodOptions,
                                          rules: [_vm.rules.required]
                                        },
                                        model: {
                                          value: _vm.method,
                                          callback: function($$v) {
                                            _vm.method = $$v
                                          },
                                          expression: "method"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-item",
                                [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v("READ_DEPTH")
                                      ]),
                                      _vm._v(" "),
                                      _c("v-text-field", {
                                        ref: "read_depth",
                                        attrs: {
                                          label:
                                            "The value to filter the Read Depth(if value is 20000, filtering under 20000)"
                                        },
                                        model: {
                                          value: _vm.read_depth,
                                          callback: function($$v) {
                                            _vm.read_depth = $$v
                                          },
                                          expression: "read_depth"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticStyle: { flex: "1 1 auto" } })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-app",
        [
          _c(
            "v-dialog",
            {
              attrs: {
                "hide-overlay": "",
                "max-width": "600",
                transition: "dialog-bottom-transition",
                scrollable: ""
              },
              model: {
                value: _vm.dialogShell,
                callback: function($$v) {
                  _vm.dialogShell = $$v
                },
                expression: "dialogShell"
              }
            },
            [
              _c(
                "v-card",
                { attrs: { tile: "", height: "800px" } },
                [
                  _c(
                    "v-toolbar",
                    {
                      attrs: { flat: "", dark: "", color: "primary darken-1" }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "", dark: "" },
                          on: {
                            click: function($event) {
                              _vm.dialogShell = false
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("mdi-close")])],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-toolbar-title", [_vm._v("Pipeline Settings")]),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { dark: "", text: "" },
                              on: {
                                click: function($event) {
                                  return _vm.addRun()
                                }
                              }
                            },
                            [
                              _c("v-icon", [
                                _vm._v(
                                  "\n                      mdi-desktop-mac-dashboard\n                    "
                                )
                              ]),
                              _vm._v(
                                "\n                      Run\n                  "
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-menu", {
                        attrs: { bottom: "", right: "", "offset-y": "" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-list",
                        { attrs: { "three-line": "", subheader: "" } },
                        [
                          _c("v-subheader", [_vm._v("User Controls")]),
                          _vm._v(" "),
                          _c(
                            "v-form",
                            { ref: "form", attrs: { "lazy-validation": "" } },
                            [
                              _c(
                                "v-list-item",
                                [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v("Serial")
                                      ]),
                                      _vm._v(" "),
                                      _c("v-text-field", {
                                        ref: "serial",
                                        attrs: {
                                          label: "Serial",
                                          rules: [
                                            _vm.rules.required,
                                            _vm.rules.blank
                                          ],
                                          required: ""
                                        },
                                        model: {
                                          value: _vm.serial,
                                          callback: function($$v) {
                                            _vm.serial = $$v
                                          },
                                          expression: "serial"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-item",
                                [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v("Input Path")
                                      ]),
                                      _vm._v(" "),
                                      _c("v-text-field", {
                                        ref: "inputPath",
                                        attrs: {
                                          label: "Input Path",
                                          rules: [
                                            _vm.rules.required,
                                            _vm.rules.blank
                                          ],
                                          required: ""
                                        },
                                        model: {
                                          value: _vm.inputPath,
                                          callback: function($$v) {
                                            _vm.inputPath = $$v
                                          },
                                          expression: "inputPath"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-item",
                                [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v("Database")
                                      ]),
                                      _vm._v(" "),
                                      _c("v-select", {
                                        ref: "database",
                                        attrs: {
                                          items: _vm.databaseOptions,
                                          rules: [_vm.rules.required]
                                        },
                                        model: {
                                          value: _vm.database,
                                          callback: function($$v) {
                                            _vm.database = $$v
                                          },
                                          expression: "database"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-item",
                                [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v("MIN_DEPTH")
                                      ]),
                                      _vm._v(" "),
                                      _c("v-text-field", {
                                        ref: "min_depth",
                                        attrs: {
                                          label:
                                            "Minimum depth of samples to use for analysis, If the values is 0, depth would be automatically set."
                                        },
                                        model: {
                                          value: _vm.min_depth,
                                          callback: function($$v) {
                                            _vm.min_depth = $$v
                                          },
                                          expression: "min_depth"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-item",
                                [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v("MAX_DEPTH")
                                      ]),
                                      _vm._v(" "),
                                      _c("v-text-field", {
                                        ref: "max_depth",
                                        attrs: {
                                          label:
                                            "Maximum depth of samples to use for analysis, If the values is 0, depth would be automatically set."
                                        },
                                        model: {
                                          value: _vm.max_depth,
                                          callback: function($$v) {
                                            _vm.max_depth = $$v
                                          },
                                          expression: "max_depth"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-item",
                                [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v("GROUP")
                                      ]),
                                      _vm._v(" "),
                                      _c("v-select", {
                                        ref: "group",
                                        attrs: {
                                          items: _vm.groupOptions,
                                          rules: [_vm.rules.required],
                                          label:
                                            "OPTION: single, common or group"
                                        },
                                        model: {
                                          value: _vm.group,
                                          callback: function($$v) {
                                            _vm.group = $$v
                                          },
                                          expression: "group"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-item",
                                [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v("REGION")
                                      ]),
                                      _vm._v(" "),
                                      _c("v-select", {
                                        ref: "region",
                                        attrs: {
                                          items: _vm.regionOptions,
                                          rules: [_vm.rules.required],
                                          label: "OPTION: v3v4,v4 or its"
                                        },
                                        model: {
                                          value: _vm.region,
                                          callback: function($$v) {
                                            _vm.region = $$v
                                          },
                                          expression: "region"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-item",
                                [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [_vm._v("TYPE")]),
                                      _vm._v(" "),
                                      _c("v-select", {
                                        ref: "type",
                                        attrs: {
                                          items: _vm.typeOptions,
                                          rules: [_vm.rules.required],
                                          label:
                                            'FASTQ TYPE, default is "paired". specify "single" if you use single-end or merged fastq'
                                        },
                                        model: {
                                          value: _vm.type,
                                          callback: function($$v) {
                                            _vm.type = $$v
                                          },
                                          expression: "type"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-item",
                                [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v("REMOVE_MT_CP")
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "v-radio-group",
                                        {
                                          ref: "remove_mt",
                                          attrs: {
                                            inline: "",
                                            label:
                                              "remove the mictochondria and chlorophlast in taxonomy profile"
                                          },
                                          model: {
                                            value: _vm.remove_mt,
                                            callback: function($$v) {
                                              _vm.remove_mt = $$v
                                            },
                                            expression: "remove_mt"
                                          }
                                        },
                                        [
                                          _c("v-radio", {
                                            attrs: { label: "Y", value: "Y" }
                                          }),
                                          _vm._v(" "),
                                          _c("v-radio", {
                                            attrs: { label: "N", value: "N" }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticStyle: { flex: "1 1 auto" } })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "h6",
        { staticClass: "modal-title", attrs: { id: "exampleModalLabel5" } },
        [_vm._v("Chat")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close"
          }
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "h6",
        { staticClass: "modal-title", attrs: { id: "exampleModalLabel6" } },
        [_vm._v("New Task")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close"
          }
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h6", [
      _c("span", { staticClass: "badge badge-danger" }, [
        _vm._v("please select a pipeline")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h6", [
      _c("span", { staticClass: "badge badge-light" }, [_vm._v("Serial")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h6", [
      _c("span", { staticClass: "badge badge-light" }, [_vm._v("INPUT_PATH")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h6", [
        _c("span", { staticClass: "badge badge-light" }, [_vm._v("Serial")])
      ]),
      _vm._v(" "),
      _c("input", {
        staticClass: "form-control mb-1",
        staticStyle: { width: "20rem" },
        attrs: { type: "form-control" }
      }),
      _vm._v(" "),
      _c("h6", [
        _c("span", { staticClass: "badge badge-light" }, [_vm._v("INPUT_PATH")])
      ]),
      _vm._v(" "),
      _c("input", {
        staticClass: "form-control",
        staticStyle: { width: "27rem" },
        attrs: { type: "form-control" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "h5",
        { staticClass: "modal-title", attrs: { id: "exampleModalLabel5" } },
        [_vm._v("Task Info")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close"
          }
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b0bffea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b0bffea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Analysis/Microbiome/List2.vue
// module id = null
// module chunks = 